module.exports = __webpack_public_path__ + "static/google-icon.1a01e56f.svg";